module.exports = __webpack_public_path__ + "media/application/images/demsoc/tiles/monochrome_1-df456b90237db301bd44bc19e784e5e9.jpg";